export default __webpack_public_path__ + "static/media/IC00040-edit_org.75e4808f.svg";